<template>
  <v-tabs v-model="model" class="mt-4 pl-4">
    <v-tab href="#locale-ja" @click="$store.commit('changeLocaleJa')">日本語</v-tab>
    <v-tab href="#locale-en" @click="$store.commit('changeLocaleEn')">English</v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "Locale",
  data() {
    return {
      model: this.$store.state.localeEn ? "locale-en" : "locale-ja",
    };
  },
};
</script>

<style scoped></style>
